<template>
  <div id="hres4ax-popup1-tab3" class="panel box-collapse border-color-skin">
    <div class="box-header with-border box-header-collapse collapsed  tab-header" data-toggle="collapse" data-parent="#accordion" href="#popup1tab3">
      <h3 class="box-title">
        <i class="fa fa-file-text-o margin-r-5 margin-r-5"></i>{{ labels['HRES4AXC4']['300'] }}
      </h3>
    </div>
    <div id="popup1tab3" class="panel-collapse collapse tab-detail">
      <div class="panel-body">
        <div class="detail detail-responsive panel-detail-filter">
          <hrms-table :columns="popup1Tab3Table" 
                      :data="data"
                      :searchDisp="false"  />
        </div>
      </div>
      <div class="modal-footer" >
      </div>
    </div>
  </div>

</template>

<script>
export default {
  name: 'hres4ax-popup1-tab3',
  props: [ 'labels', 'data', 'popup1Tab3Table' ]
}
</script>


// WEBPACK FOOTER //
// popup1Tab3.vue?4855fc0b